// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NLQVisualization.jsx" company="Izenda">
//  Copyright (c) 2020 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.aaa
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { PureComponent } from 'react';
import Icon from 'share/components/controls/Izenda.Icon';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import ReportViewerContent from '../../Reports/ReportViewer/Izenda.ReportViewerContent';
import ReportDesignerStore from 'logic/Izenda.ReportDesignerStore';
import ReportDesignerFieldsStore from 'logic/Izenda.ReportDesignerFieldsStore';
import ReportsStore from 'logic/Izenda.ReportsStore';
import NLQSavePopup from 'share/components/controls/NLQSavePopup/Izenda.NLQSavePopup';
import NLQSaveDashBoardPopup from 'share/components/controls/NLQSaveDashBoardPopup/Izenda.NLQSaveDashBoardPopup';
import NLQIsReportSavePopup from 'share/components/controls/NLQIsReportSavePopup/Izenda.NLQIsReportSavePopup';
import Alert from 'share/components/controls/Izenda.Alert';
import { PERMISSION_KEY } from 'logic/data/Izenda.AuthorizationConstants';
import { LICENSE_KEY } from 'logic/data/Izenda.LicenseCheckerConstants';
import MessageNotification from 'share/components/controls/MessageNotification';
import AuthorizationValidator from 'share/components/hoc/Izenda.AuthorizationValidator';
import ExportButton from 'share/components/controls/Izenda.ExportButton';
const ExportReportBtn = AuthorizationValidator()(ExportButton);

import { isNil } from 'lodash/fp';
import DashboardConstants from 'logic/data/Izenda.DashboardConstants';
const INTERVAL = 2000;
class NLQVisualization extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showSetting: true,
      isShowSettingExpanded: false,
      isHovering: false,
      currentActiveVisualizationType:
        props.store.model.nlqVisualizationReportDefinition.reportPart[0]
          .reportPartContent.properties.chartType,
      hoverActivevisualization: null,
      isSave: false,
      isDashboardSave: false,
      isStatus: false,
      isDashboardStatus: false,
      isDownloadComplete: false
    };

    this.masterStore = new ReportDesignerStore(
      true,
      '',
      null,
      null,
      false,
      true,
      this.props.store.model.nlqVisualizationReportDefinition
    );
    this.masterStore.model.markDirty();
    this.reportDesignerFieldsStore = new ReportDesignerFieldsStore(
      this.masterStore,
      true,
      0,
      this.props.store
    );

    if (
      props.store.model.nlqVisualizationReportDefinition.reportPart[0]
        .reportPartContent.properties.chartType == 'SolidGauge'
    ) {
      this.reportDesignerFieldsStore.setNeedToExploreStoreReportInfoUpdate(
        true
      );
    }

    this.reportStore = new ReportsStore();
    props.store.loadALLReports(null, this.masterStore);
  }

  /**
   * Set ref to content
   * @param {Object} node
   */

  componentWillUnmount() {
    this.props.store.resetAlertDetails();
  }
  showSettingInfo() {
    this.setState({
      isShowSettingExpanded: !this.state.isShowSettingExpanded
    });
  }
  handleMouseHover = (visualizeInfo) => {
    this.setState({
      isHovering: true,
      hoverActivevisualization: visualizeInfo
    });
  };
  handleMouseHoverLeave = () => {
    this.setState({ isHovering: false });
  };
  toggleHoverState(state) {
    return {
      isHovering: !state.isHovering
    };
  }

  setViewerContentRef = (node) => {
    this.viewerContentNode = node;
    this.updateViewerContentHeight();
  };

  updateViewerContentHeight = () => {
    if (this.viewerNode) {
      const { top, height } = this.viewerNode.getBoundingClientRect();
      const newFooterHeight = window.innerHeight - top - height;
      newFooterHeight !== this.footerHeight &&
        (this.footerHeight = newFooterHeight);
    }

    if (this.viewerContentNode) {
      const { top } = this.viewerContentNode.getBoundingClientRect();
      const newViewerContentHeight =
        window.innerHeight - top - this.footerHeight;
      newViewerContentHeight !== this.viewerContentHeight &&
        (this.viewerContentHeight = newViewerContentHeight);
    }
  };

  setVisualizationRecommendation = (selectedVisualization) => {
    if (
      selectedVisualization.chartType ===
      this.state.currentActiveVisualizationType
    )
      return false;
    if (selectedVisualization.chartType == 'SolidGauge') {
      this.reportDesignerFieldsStore.setNeedToExploreStoreReportInfoUpdate(
        true
      );
    } else {
      this.reportDesignerFieldsStore.setNeedToExploreStoreReportInfoUpdate(
        false
      );
    }

    if (!selectedVisualization.isRecommended) return false;
    let reportDef = this.props.store.model.nlqVisualizationRecommendationList.filter(
      (e) => e.visualizationType == selectedVisualization.chartType
    );
    
    if (reportDef.length > 0) {
      this.reportDesignerFieldsStore.exploreRecord = this.props.store.getVisualizationRecords;
      this.masterStore.model.read(reportDef[0].visualizationReportDefinition);
      this.masterStore.model.changeName(selectedVisualization.reportName);
      this.masterStore.model.resetReportKey(selectedVisualization.reportId);
    }
    this.masterStore.model.setReportPartTitle('');
    this.setState({
      currentActiveVisualizationType: selectedVisualization.chartType,
      isSave: selectedVisualization.isSave,
      isDashboardSave: selectedVisualization.isDashboardSave,
      reportId:selectedVisualization.reportId,
      reportName:selectedVisualization.reportName
    });
  };

  rendervisualizationRecommendationList() {
    const activeCharttype = this.state.currentActiveVisualizationType
      ? this.state.currentActiveVisualizationType
      : 'Grid';

    return this.props.store.getVisualizationRecommendationList.map(
      (visualizeInfo, i) => {
        return (
          <div
            className={`chart-box-col  ${
              activeCharttype == visualizeInfo.chartType ? 'active' : ''
            }`}
            x
            onMouseEnter={this.handleMouseHover.bind(
              this,
              visualizeInfo.visuliazationInfo
            )}
            onMouseLeave={this.handleMouseHoverLeave.bind(this, '')}
            key={i}
            onClick={this.setVisualizationRecommendation.bind(
              this,
              visualizeInfo
            )}
          >
            <div
              title={visualizeInfo.chartType}
              className={`chart-box ${
                visualizeInfo.sectionStyle.backgroundImage
              } ${!visualizeInfo.isRecommended ? 'disabled' : ''}`}
            ></div>
            {visualizeInfo.isRecommended && (
              <span className='label-box'>
                {visualizeInfo.isRecommended
                  ? visualizeInfo.recommendedText
                  : visualizeInfo.chartType}
              </span>
            )}
          </div>
        );
      }
    );
  }

  renderVisualization(visualizeInfo) {
    if (visualizeInfo && visualizeInfo.rules.length > 0) {
      let rules = visualizeInfo.rules.map((rule, i) => {
        return (
          <div key={i} className='info-btn-wrapper'>
            <span className='info-text'>{rule.Number}</span>
            <button
              className='info-btn'
              style={{ backgroundColor: rule.bgColor ? rule.bgColor : '' }}
            >
              <i className={rule.icon}></i>
              {rule.type}
            </button>
          </div>
        );
      });
      return (
        <div className='setting-chart-info'>
          <p>
            <strong>{visualizeInfo.name}</strong>
          </p>
          {rules}
        </div>
      );
    } else {
      return null;
    }
  }

  onSaveReport = () => {
    this.masterStore.model.resetReportKey(null);
    this.openPopup();
  };

  /**
   * Open SavePopup
   * @return {Promise}
   */
  openPopup() {
    const {
      props,
      onSaveStatus,
      masterStore,
      props: { store: exploreStore, localization }
    } = this;
    const loadPromise =
      isNil(masterStore.model.categoryId) || masterStore.saveAsMode
        ? masterStore.loadCategories()
        : Promise.join(
            masterStore.loadCategories(),
            masterStore.loadSubCategories(masterStore.model.categoryId)
          );

    loadPromise.then(() =>
      props.openPopup(NLQSavePopup, {
        store: masterStore,
        localizer: localization,
        exploreStore: exploreStore,
        onSaveStatus: onSaveStatus
      })
    );
  }

  onSaveDashBoard = () => {
    this.openPopupDashBoard();
  };
  

  openPopupDashBoard() {
    const {
      masterStore,
      onSaveDashboardStatus,
      props: { store: exploreStore, localization, authorizationConstants, 
        store: {
          storeDashboard : {
          model: {
            dashboardDetail          }        },
        storeDashboard
        }
      }
    } = this;
    this.props.openPopup(NLQSaveDashBoardPopup, {
      store: masterStore,
      localizer: localization,
      exploreStore: exploreStore,
      onSaveDashboardStatus: onSaveDashboardStatus,
      authorizationConstants: authorizationConstants,
      reportName:this.state.reportName,
      popupConfig: DashboardConstants.SAVE_POPUP_CONFIG,
      getCategoriesFunc:storeDashboard.lazyLoadCategories,
      changeName:dashboardDetail.changeName.bind(dashboardDetail),
      changeCategoryType:dashboardDetail.changeCategoryType.bind(dashboardDetail),
      changeCategory:dashboardDetail.changeCategory.bind(dashboardDetail),
      changeDashboard:dashboardDetail.changeDashboard.bind(dashboardDetail),
    });
  }

  onSaveIsReport = () => {
    this.openSaveIsReport(false);
  };

  openSaveIsReport(status) {
    const {
      props: { localization }
    } = this;
    this.props.openPopup(NLQIsReportSavePopup, {
      localizer: localization,
      openSaveReportFun: this.onSaveReport.bind(this),
      isExportClick:status
    });
  }

  onSaveDashboardStatus = (status) => {
    const currentActiveVisualizationType = this.state
      .currentActiveVisualizationType;
    this.props.store.model.visualizationRecommendationList.forEach(
      (visualizeInfo) => {
        if (currentActiveVisualizationType == visualizeInfo.chartType)
          visualizeInfo.isDashboardSave = true;
      }
    );
    this.setState({ isDashboardSave: status });
  };

  onSaveReportAgain = () => {
    const { store, localization } = this.props;
    store.alertDetails.set({
      success: true,
      message: localization.getText('NLQ_MODAL_REPORT_ALREADY_CREATED_MSG'),
    });

    setTimeout(function() {
      store.alertDetails.reset();
    }, INTERVAL);
    this.setState({ isStatus: !this.state.isStatus });
  };

  onSaveDashBoardAgain = () => {
    const { store, localization } = this.props;
    store.alertDetails.set({
      success: true,
      message: localization.getText('NLQ_MODAL_DASHBOARD_ALREADY_CREATED_MSG')
    });

    setTimeout(function() {
      store.alertDetails.reset();
    }, INTERVAL);
    this.setState({ isDashboardStatus: !this.state.isDashboardStatus });
  };

  onSaveStatus = (status) => {
    const {
      masterStore:{model:{reportName,reportId}},
      props:{store: exploreStore}
    } = this;
    const currentActiveVisualizationType = this.state
      .currentActiveVisualizationType;
      exploreStore.model.visualizationRecommendationList.forEach(
      (visualizeInfo) => {
        if (currentActiveVisualizationType == visualizeInfo.chartType) {
          visualizeInfo.isSave = true;
          visualizeInfo.reportName = reportName;
          visualizeInfo.reportId = reportId;
        }
      }
    );

    this.setState({ isSave: status ,reportName: reportName,reportId:reportId});
  };

  isReportActive = () => {
    this.openSaveIsReport(true);
  }

  isDownloadCompleted = downloadStatusValue => { 
     const { isDownloadComplete  } = this.state;
     const { store,localization } = this.props;
     let tempIsDownloadComplete = {...isDownloadComplete}; 
     if(downloadStatusValue === true ){
        store.alertDetails.set({
          success: true,
          message: localization.getText('NOTIFICATION_DOWNLOAD_COMPLETE')
        });
     } else if(downloadStatusValue === false){
        store.alertDetails.reset();
     }
     this.setState({
       isDownloadComplete: tempIsDownloadComplete
     });
  };

  render() {
    const {
      isShowSettingExpanded,
      hoverActivevisualization,
      isSave,
      isStatus,
      isDashboardSave,
      isDashboardStatus,
    } = this.state;
    const renderVisualization = this.renderVisualization(
      hoverActivevisualization
    );
    const {
      store: {
        alertDetails: { message, alertType }
      },
      authorization,
    } = this.props || {};
    const hasExportLicense = authorization.checkLicense(LICENSE_KEY.Exporting);
    const { masterModel: {displayMode} } = this.reportDesignerFieldsStore;
    const {reportId,reportName} = this.state;
    return (
      <div className='report-viewer-content  w_96'>
        <ScrollBox>
          <div className='explore-visualization-wrapper'>
            <div className='explore-report-header clearfix'>
              <div className='visualization-title-wrapper'>
                <Alert type={alertType}>{message}</Alert>
                <h1>
                  {isStatus}
                  {isDashboardStatus}
                </h1>
              </div>
              <div className='visualization-actions-wrapper'>
                <button
                  className='action-btn'
                  onClick={
                    !isSave
                      ? this.onSaveReport.bind(this)
                      : this.onSaveReportAgain.bind(this)
                  }
                >
                  <Icon className='icon-save-report' title='Save Report' />
                </button>              
                <button
                    className='action-btn'
                    onClick={
                      !isSave ? this.onSaveIsReport.bind(this) :
                      !isDashboardSave
                        ? this.onSaveDashBoard.bind(this)
                        : this.onSaveDashBoardAgain.bind(this)
                    }
                  >
                    <Icon
                      className='icon-save-dashboard'
                      title='Add to Dashboard'
                    />
                  </button>
                  {hasExportLicense && (
                    <ExportReportBtn
                        name={reportName}
                        store={this.reportStore}
                        export={this.reportStore.exportReport}
                        designerStore={this.masterStore}
                        id={reportId}
                        disabled={displayMode.doesDisableExportBtn}
                        keys={[PERMISSION_KEY.ReportsActionsExporting]}
                        isNLQVisualization={true}
                        isNLQVisualizationActive={isSave}
                        isReportActive={this.isReportActive}
                        isDownloadCompleted={this.isDownloadCompleted}
                    />
                  )}
              </div>
            </div>
            <div
              className={`explore-visualization-body clearfix ${
                isShowSettingExpanded ? 'visible-open' : ' '
              }`}
            >
              <div className='report-wrapper'>
                <ReportViewerContent
                  setViewerContentRef={this.setViewerContentRef}
                  className='content-container'
                  bottom={400}
                  {...this.props}
                  store={this.reportDesignerFieldsStore}
                  reportViewerStore={this.reportStore}
                  viewerContentHeight={400}
                />
              </div>
              <div className='explore-visualization-settings'>
                <div
                  className={`setting-tab-content ${
                    isShowSettingExpanded ? 'collapse' : 'expand'
                  }`}
                >
                  <div className='seting-tab-header'>
                    <button
                      className='collapse-setting-btn'
                      onClick={() => this.showSettingInfo()}
                    >
                      <Icon className='icon-arrow-right' />
                    </button>
                    <Icon className='icon-bar-chart ' />
                    Visual Styles
                  </div>
                  <div className='setting-tab-body'>
                    <div className='chart-type-wrapper clearfix'>
                      {this.rendervisualizationRecommendationList()}
                    </div>

                    {/* change */}
                    <div className='chart-type-definition-section'>
                      {this.state.isHovering && renderVisualization}
                    </div>
                  </div>
                </div>
                <div
                  className={`setting-tab-wrapper ${
                    isShowSettingExpanded ? ' d-block' : 'd-none'
                  }`}
                >
                  <div className='u_textRight'>
                    <div
                      className='setting-tab'
                      onClick={() => this.showSettingInfo()}
                    >
                      <Icon className='icon-arrow-right icon-arrow-left' />
                      <Icon className='icon-bar-chart ' />
                      Visual Styles
                    </div>
                  </div>
                  <div className='u_textRight' style={{ display: 'none' }}>
                    <div className='setting-tab'>
                      <Icon className='icon-cancel' /> Field Properties
                    </div>
                  </div>
                  <div className='u_textRight' style={{ display: 'none' }}>
                    <div className='setting-tab'>
                      <Icon className='icon-cancel' /> Report Properties
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollBox>
      </div>
    );
  }
}

export default NLQVisualization;


// WEBPACK FOOTER //
// ./ui/modules/Explore/NLQVisualization/Izenda.NLQVisualization.jsx